export default "/event-layout-custom.17f6d0ef-0f8fec.png";